<div class="row">

    <!-- Smart Cache (optional)
    <div class="col-xxl-3 col-sm-6">
        <app-smart-cache-dashboard></app-smart-cache-dashboard>
    </div>
    -->

    <!-- Metrics Cards -->
    <div class="col-xxl-3 col-sm-6" *ngIf="hasRoles([RoleEnum.ProductMaster])">
        <app-total-sales [dashboardCounter]="dashboardCounter"></app-total-sales>
    </div>

    <div class="col-xxl-3 col-sm-6" *ngIf="hasRoles([RoleEnum.ProductMaster, RoleEnum.ClientSuperAdmin])">
        <app-total-transactions [dashboardCounter]="dashboardCounter"></app-total-transactions>
    </div>

    <div class="col-xxl-3 col-sm-6" *ngIf="hasRoles([RoleEnum.ProductMaster, RoleEnum.ClientSuperAdmin])">
        <app-average-order-value [dashboardCounter]="dashboardCounter"></app-average-order-value>
    </div>

    <div class="col-xxl-3 col-sm-6" *ngIf="hasRoles([RoleEnum.ProductMaster, RoleEnum.ClientSuperAdmin])">
        <app-total-discount [dashboardCounter]="dashboardCounter"></app-total-discount>
    </div>

    <!-- Order Stats (ClientSuperAdmin only) -->
    <div class="col-12" *ngIf="hasRoles([RoleEnum.ClientSuperAdmin])">
        <app-order-stats [dashboardCounter]="dashboardCounter"></app-order-stats>
    </div>

    <!-- Recent Orders table (ClientSuperAdmin only) -->
    <div class="col-12" *ngIf="hasRoles([RoleEnum.ClientSuperAdmin])">
        <app-recent-orders [dashboardCounter]="dashboardCounter"></app-recent-orders>
    </div>

    <!-- Other widgets -->
    <div class="col-lg-8">
        <!-- <app-sales-analytics></app-sales-analytics> -->
    </div>

    <div class="col-lg-4">
        <!-- <app-customer-segmentation></app-customer-segmentation> -->
    </div>

    <div class="col-xxl-8">
        <!-- <app-categories></app-categories> -->
    </div>

    <div class="col-xxl-4">
        <!-- <app-order-details></app-order-details> -->
    </div>

</div>